<template>
    <div class="garantie-view">
        <div class="garantie-view__head">
            <div class="garantie-view__head--icon" @click="$router.push('/devis')" v-if="showRetourButton">
                <font-awesome-icon prefix="fas" icon="arrow-circle-left"/>
                Retour
            </div>
        </div>
        <div class="garantie-view__head">
            <div class="garantie-view__head--title">
                Devis en ligne
            </div>
        </div>
        <div class="garantie-view__body">
            <div class="garantie-view__body__block">
                <div class="garantie-view__body__block--title">
                    Informations sur le propriétaire du véhicule :
                </div>
                <div class="garantie-view__body__block--content" v-if="!isBusy && guaranty">
                    <div class="title">Vos coordonnées :</div>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Civilité:</div>
                                <div class="field__value">{{showGender}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Nom:</div>
                                <div class="field__value">{{guaranty.last_name || ''}}</div>
                            </div>
                        </div>
                        <template v-if="+guaranty.civility !== CLIENT_CIVILITY.SOCIETE.ID">
                            <div class="col-12 col-md-6" v-if="guaranty.first_name">
                                <div class="field">
                                    <div class="field__label">Prénom:</div>
                                    <div class="field__value">{{guaranty.first_name || ''}}</div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-12 col-md-6" v-if="guaranty.name_of_signatory">
                                <div class="field">
                                    <div class="field__label">Nom du signataire:</div>
                                    <div class="field__value">{{guaranty.name_of_signatory}}</div>
                                </div>
                            </div>
                        </template>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Adresse:</div>
                                <div class="field__value">{{guaranty.address || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Code postal:</div>
                                <div class="field__value">{{guaranty.cp || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Ville :</div>
                                <div class="field__value">{{guaranty.ville || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Téléphone:</div>
                                <div class="field__value">{{guaranty.tel || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Fax:</div>
                                <div class="field__value">{{guaranty.fax || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Email:</div>
                                <div class="field__value">{{guaranty.email || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Date De Naissance:</div>
                                <div class="field__value">{{showDateDeNaissance(guaranty) || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Family:</div>
                                <div class="field__value">{{showFamilyStatus}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Profession:</div>
                                <div class="field__value">{{showProfession}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="field">
                                <div class="field__label">Date De Permis:</div>
                                <div class="field__value">{{showDateDePermiss(guaranty)}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <Preloader v-if="isBusy"/>
                <div class="garantie-view__body__block--title">
                    Informations sur le Camping-car à assurer :
                </div>
                <div class="garantie-view__body__block--content" v-if="!isBusy && guaranty">
                    <div class="title">Votre Camping-car :</div>
                    <div class="row">
                        <!--<div class="col-12">-->
                            <!--<div class="field">-->
                                <!--<div class="field__label field__label&#45;&#45;bold">Camping car neuf:</div>-->
                                <!--<div class="field__value">{{isNewCar(guaranty)}}</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="col-12">-->
                            <!--<div class="field">-->
                                <!--<div class="field__label field__label&#45;&#45;bold">Durée:</div>-->
                                <!--<div class="field__value">{{showDuration}}</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Immatriculation:</div>
                                <div class="field__value">{{guaranty.registration || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Marque du porteur:</div>
                                <div class="field__value">{{guaranty.marque_porteur || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Modèle du porteur:</div>
                                <div class="field__value">{{guaranty.modele_porteur || ''}}</div>
                            </div>
                        </div>
                        <!--<div class="col-12">-->
                            <!--<div class="field">-->
                                <!--<div class="field__label field__label&#45;&#45;bold">Marque cellule:</div>-->
                                <!--<div class="field__value">{{guaranty.details.marque_cellule || ''}}</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<div class="col-12">-->
                            <!--<div class="field">-->
                                <!--<div class="field__label field__label&#45;&#45;bold">Modèle cellule:</div>-->
                                <!--<div class="field__value">{{guaranty.details.modele_cellule || ''}}</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Date de 1ère mise en circulation:</div>
                                <div class="field__value">{{parseCirculationDate(guaranty) || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Numéro de série:</div>
                                <div class="field__value">{{guaranty.serial_number || ''}}</div>
                            </div>
                        </div>
                        <!--<div class="col-12">-->
                            <!--<div class="field">-->
                                <!--<div class="field__label field__label&#45;&#45;bold">Puissance fiscale:</div>-->
                                <!--<div class="field__value">{{guaranty.fiscal_power || ''}}</div>-->
                            <!--</div>-->
                        <!--</div>-->
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Valeur:</div>
                                <div class="field__value">{{guaranty.valeur || ''}} €</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Date d'effet:</div>
                                <div class="field__value">{{parseEffectiveDate(guaranty)}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Bonus:</div>
                                <div class="field__value">{{showBonus}}</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="field">
                                <div class="field__label field__label--bold">Poids Total Autorisé En Charge (PTC):</div>
                                <div class="field__value">{{showPTC}}</div>
                            </div>
                        </div>
                        <div class="col-12" v-if="guaranty.finance == 1">
                          <div class="field">
                            <div class="field__label field__label--bold">Organisme de financement:</div>
                            <div class="field__value">{{guaranty.finance_name}}</div>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="garantie-view__body__block--warning" v-if="numberOfDuplicates>0">
                    Attention ! Un contrat a déjà été saisi avec ce nom et ce numéro d’immatriculation.
                </div>
                <div class="garantie-view__body__block--link">
                    <router-link :to="/devis-en-ligne-assurance/ + $route.params.id">Cliquer ici pour modifier vos
                        coordonnées
                    </router-link>
                </div>
                <Preloader v-if="isBusy"/>
            </div>
            <div class="garantie-view__body__block mt-3">
                <div class="garantie-view__body__block--title">
                    VOUS AVEZ CHOISI L’ASSURANCE TOUS RISQUES POUR UNE DURÉE DE 12 MOIS
                </div>

                <div class="garantie-view__body__block--content">
                    <div class="description">
                        <div class="label mb-2">
                            <div class="label--bold rem-18">Dur&eacute;e et prise d'effet</div>
                        </div>

                        <div class="font-weight-bold rem-14">
                            Sous r&eacute;serve du paiement de la prime et de l'acceptation de la garantie par
                            <strong>Dynassurances</strong>,
                            la garantie s'applique suivant la dur&eacute;e pr&eacute;cis&eacute;e aux conditions
                            particuli&egrave;res du contrat et prendra fin automatiquement &agrave; 24 heures jour pour
                            jour selon les dates indiqu&eacute;es sur le certificat de garantie.
                            <br/>
                            Cependant la garantie prendra fin de plein droit avant son terme :
                        </div>

                        <div class="list mt-3 rem-14">
                            <ul class="list__ul font-weight-bold">
                                <li>en cas de d&eacute;ch&eacute;ance du b&eacute;n&eacute;ficiaire de la garantie pour
                                    non respect des prescriptions du constructeur sur l'usage pour lequel le v&eacute;hicule
                                    est con&ccedil;u.
                                </li>
                            </ul>
                        </div>
                        <br class="mt-5">
                        <div class="price-block-new">
                            <div class="row">
                                <div class="col">
                                    <strong>«Cotisation annuelle TTC :</strong>
                                </div>
                                <div class="col text-right" style="padding-right: 80px;">
                                    <span><strong>{{getRegularPrice(guaranty)}}</strong></span>»
                                </div>
                            </div>
                            <template v-if="isPackAssistance(guaranty.details)">
                              <div class="row">
                                  <div class="col">
                                      <strong> «Abonnement Masters Pack Assistance pour une durée de 12 mois renouvelable (voir conditions): {{showAssistancePrice(guaranty)}}»</strong>
                                  </div>
                              </div>
                            </template>
                        </div>
                        <div class="insurance-info">
                            <div class="insurance-info__buttons">
                                <div
                                    class="insurance-info__buttons__item insurance-info__buttons__item--50 text-sm-right">
                                    <div class="insurance-info__buttons--wrapper">
                                        <a href="#" @click.prenevt="printInsurance()" class="blue">Imprimer le devis d’assurance</a>
                                        <div class="ball-anchor blue"></div>
                                    </div>
                                </div>
                                <div
                                    class="insurance-info__buttons__item insurance-info__buttons__item--50 text-sm-left">
                                    <div class="insurance-info__buttons--wrapper">
                                        <a href="#" @click.prenevt="getFrontPdf()" class="green">Sauvegarder sur mon
                                            ordinateur</a>
                                        <div class="ball-anchor green"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="garantie-view__body__block mt-3">
                    <!--Insurance additional step-->
                    <template>
                        <div class="garantie-view__body__block--title">
                            PAIEMENT DE LA PRIME
                        </div>
                        <div class="garantie-view__body__block--content">
                            <div class="description">
                                <div class="list mt-3">
                                    <ul class="list__ul">
                                        <li>
                                            <b>Paiement :</b>
                                            <div>
                                                <div class="form__item__input-wrapper form__item__input-wrapper--checkbox">
                                                    <input v-model="payment_type" type="radio" id="payment_year" value="year" :checked="payment_type === 'year'"/>
                                                    <label for="payment_year">Annuel</label>
                                                    <input v-model="payment_type" type="radio" id="payment_month" value="month" :checked="payment_type === 'month'"/>
                                                    <label for="payment_month">Mensuel</label>
                                                </div>
                                            </div>
                                        </li>
                                        <li v-if="payment_type === 'month'">
                                            <div style="float: left;">Cotisation périodique TTC</div><div style="float: left; padding-left: 441px;">{{regularMonthlyPrice}} €</div>
                                            <br>
                                            <div style="float: left;">Premier versement incluant frais et taxes pour la période du {{parseEffectiveDate(guaranty)}} au {{parseEndDateOfYearPayment(guaranty)}}</div><div style="float: left; padding-left: 50px;">{{monthlyPrice}} €</div>
                                        </li>
                                        <li v-else>
                                            <div style="float: left;">Pour la période du {{parseEffectiveDate(guaranty)}} au {{parseEffectiveDateEnd(guaranty)}}</div><div style="float: left; padding-left: 50px;">{{regularYearPrice}} €</div>
                                            <br>
                                            <div style="float: left;">Premier versement</div><div style="float: left; padding-left: 220px;">{{regularYearPrice}} €</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </template>

                    <div class="garantie-view__body__block--title">
                        Garanties accordées
                    </div>
                    <div class="garantie-view__body__block--content">
                      <div class="description">
                        <div class="list mt-3">
                          <GuarantyAssurancesSection :guaranty="guaranty"/>
                        </div>
                      </div>
                    </div>

                    <!--for reseau type-->
                    <template v-if="guaranty.details && guaranty.details.garantie == 1">
                        <div class="garantie-view__body__block--content">
                            <div class="description">
                                <div class="list mt-3">
                                    <ul class="list__ul">
                                        <li>
                                            <b>Moteur :</b>
                                            <div>
                                                L'arbre à cames, les coussinets de tête de bielle, les bielles, les
                                                culbuteurs et tiges de culbuteurs, poussoirs, chaînes de distribution,
                                                courroie de distribution (uniquement en cas de rupture), paliers de
                                                vilebrequin, vilebrequin, pistons et axes, segments, soupapes et guides,
                                                pompe à huile, culasse, joint de culasse et turbo.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Boîte de vitesse :</b>
                                            <div>
                                                <b>Manuelle</b> : Toutes les défaillances internes : Pignon, arbres,
                                                sélecteurs, synchros, roulements.
                                                <br>
                                                <b>Automatique</b> : Pignons, pompe à huile, bagues et arbres,
                                                convertisseur
                                                de couple, vannes et soupapes, régulateur, plateau.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Dans le dispositif de transmission :</b>
                                            <div>
                                                Boîte de transfert, pont arrière, différentiels, pignons et couronnes. A
                                                l'exception des arbres de roues, de transmission et des cardans.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Sont de plus garantis dans la cellule :</b>
                                            <div>
                                                Pompe à eau, chauffe-eau, agrégat réfrigérateur, transformateur et
                                                chargeur
                                                électrique, pulseur d'air.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Important :</b>
                                            <div>
                                                Cette garantie est réservée aux camping-cars de moins de 5 tonnes et
                                                moins
                                                de 120 000 Km à la souscription.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!--for maxi reseau type-->
                    <template v-else-if="guaranty.details && guaranty.details.garantie == 2">
                        <div class="garantie-view__body__block--content">
                            <div class="description">
                                <div class="list mt-3">
                                    <ul class="list__ul">
                                        <li>
                                            <b>Moteur :</b>
                                            <div>
                                                L'arbre à cames, les coussinets de tête de bielle, les bielles, les
                                                culbuteurs et tiges de culbuteurs, poussoirs, chaînes de distribution,
                                                courroie de distribution (uniquement en cas de rupture), paliers de
                                                vilebrequin, vilebrequin, pistons et axes, segments, soupapes et guides,
                                                pompe à huile, culasse, joint de culasse et turbo.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Boîte de vitesse :</b>
                                            <div>
                                                <b>Manuelle</b> : Toutes les défaillances internes : Pignon, arbres,
                                                sélecteurs, synchros, roulements.
                                                <br>
                                                <b>Automatique</b> : Pignons, pompe à huile, bagues et arbres,
                                                convertisseur de couple, vannes et soupapes, régulateur, plateau.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Dispositif de transmission :</b>
                                            <div>
                                                Boîte de transfert, pont arrière, différentiels, pignons et couronnes,
                                                cardans, arbre de transmission.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Système de refroidissement :</b>
                                            <div>
                                                Radiateur d'eau, pompe à eau, ventilateur.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Système électrique :</b>
                                            <div>
                                                Alternateur, démarreur, serrures de portes, moteur et mécanisme de
                                                lève-vitres, moteur d'essuie-glace et de toit ouvrant.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Système de direction :</b>
                                            <div>
                                                Crémaillère ou boîtier, pompe d'assistance. A l'exception de la colonne,
                                                des rotules et des biellettes.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Système de freinage :</b>
                                            <div>
                                                Maître-cylindre, servofrein, répartiteur, pompe à vide, bloc hydraulique
                                                ABS.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Système d'alimentation :</b>
                                            <div>
                                                Allumeur, module électronique d'allumage, bobine, pompe à injection,
                                                boîtier électronique d'injection, pompes d'alimentation en carburant. A
                                                l'exception des injecteurs.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Dispositif d'embrayage :</b>
                                            <div>
                                                Mécanisme, fourchette, à l'exception du récepteur et émetteur
                                                d'embrayage.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Sont de plus garantis :</b>
                                            <div>
                                                Pompe à eau, chauffe-eau, agrégat réfrigèrateur, transformateur et
                                                chargeur électrique, pulseur d'air.
                                            </div>
                                        </li>
                                        <li>
                                            <b>Important :</b>
                                            <div>
                                                Cette garantie est réservée aux camping-cars de moins de 5 tonnes et
                                                moins de 120 000 Km à la souscription.
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

                <div class="garantie-view__body__block--content">
                    <div class="description">

                        <div class="insurance-info">
                            <div class="insurance-info__buttons">
                                <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                                    <div class="insurance-info__buttons--wrapper">
                                        <router-link :to="/devis-en-ligne-assurance/ + $route.params.id" class="blue">
                                            Modifier
                                        </router-link>
                                        <div class="ball-anchor blue"></div>
                                    </div>
                                </div>
                                <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                                    <!--<template v-if="!isCheckingSubscription">-->
                                        <!--<div class="insurance-info__buttons&#45;&#45;wrapper">-->
                                            <!--<a href="#" @click.prevent="checkInsuranceSubscription(guaranty, getPDF)" class="purple">Souscrire au contrat d’assurance</a>-->
                                            <!--<div class="ball-anchor purple"></div>-->
                                        <!--</div>-->
                                    <!--</template>-->
                                    <!--<template v-else>-->
                                        <div class="insurance-info__buttons--wrapper">
                                            <a href="#" @click.prevent="getInsuranceSubscription(guaranty, getPDF, payment_type)" class="purple">Confirmer</a>
                                            <div class="ball-anchor purple"></div>
                                        </div>
                                    <!--</template>-->
                                </div>
                                <div class="insurance-info__buttons__item insurance-info__buttons__item--33">
                                    <div class="insurance-info__buttons--wrapper">
                                        <router-link v-if="!showRetourButton" :to="'/'" class="black">Fermer
                                        </router-link>
                                        <router-link v-else :to="'/devis'" class="black">Fermer</router-link>
                                        <div class="ball-anchor black"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '@/components/Preloader'
    import insuranceMethods from "@/mixins/insuranceMethods";
    import GuarantyAssurancesSection from "@/components/Garantie/DealerInsuranceCampingCar/GuarantyAssurancesSection";
    import {CLIENT_CIVILITY} from "@/constants/client";

    export default {
        name: 'DevisEnLigneAssuranceView',
        components: {
            Preloader,
            GuarantyAssurancesSection
        },
        mixins: [insuranceMethods],
        data() {
            return {
                guaranty: {},
                isBusy: false,
                isBusyResend: false,
                gender_list: [
                    'M',
                    'Mlle',
                    'Mme',
                    'Société',
                ],
                family_status_list: [
                    'Célibataire',
                    'Marié(e)',
                ],
                professions_list: [
                    '',
                    'Artisant/commerçant',
                    'Exploitant agricole',
                    'Profession libérale',
                    'Chef d\'entreprise',
                    'Salarié',
                    'Fonctionnaire',
                    'VRP',
                    'Etudiant',
                    'Sans profession',
                    'Retraité'
                ],
                guaranty_list: [
                    '',
                    'Réseau',
                    'Maxi Réseau',
                    'Maxi Pluss'
                ],
                duration_list: [
                    '',
                    '6 Mois',
                    '12 Mois',
                    '24 Mois',
                    '36 Mois',
                    '48 Mois',
                    '18 Mois',
                ],
                assistance_list: [
                    'Pack Assistance',
                    'Sans pack assistance',
                ],
                list_assistance_insurance: [
                    'Pack Assistance',
                    'Aucune',
                    'SOS Crevaison',
                    'SOS Constat',
                    'Assistance diagnostic devis mécanique Standard',
                    'Assistance diagnostic devis mécanique Platinium'
                ],
                list_ptc: [
                    '',
                    'Inférieur ou égal à 3,5 T',
                    'Supérieur à 3,5 T mais inférieur ou égal à 5 T',
                    'Supérieur à 5 T',
                ],
                list_bonus_insurance: [
                    '0.50 soit 50% de bonus',
                    '0.51 soit 49% de bonus',
                    '0.52 soit 48% de bonus',
                    '0.53 soit 47% de bonus',
                    '0.54 soit 46% de bonus',
                    '0.55 soit 45% de bonus',
                    '0.56 soit 44% de bonus',
                    '0.57 soit 43% de bonus',
                    '0.58 soit 42% de bonus',
                    '0.59 soit 41% de bonus',
                    '0.60 soit 40% de bonus',
                    '0.61 soit 39% de bonus',
                    '0.62 soit 38% de bonus',
                    '0.63 soit 37% de bonus',
                    '0.64 soit 36% de bonus',
                    '0.65 soit 35% de bonus',
                    '0.66 soit 34% de bonus',
                    '0.67 soit 33% de bonus',
                    '0.68 soit 32% de bonus',
                    '0.69 soit 31% de bonus',
                    '0.70 soit 30% de bonus',
                    '0.71 soit 29% de bonus',
                    '0.72 soit 28% de bonus',
                    '0.73 soit 27% de bonus',
                    '0.74 soit 26% de bonus',
                    '0.75 soit 25% de bonus',
                    '0.76 soit 24% de bonus',
                    '0.77 soit 23% de bonus',
                    '0.78 soit 22% de bonus',
                    '0.79 soit 21% de bonus',
                    '0.80 soit 20% de bonus',
                    '0.81 soit 19% de bonus',
                    '0.82 soit 18% de bonus',
                    '0.83 soit 17% de bonus',
                    '0.84 soit 16% de bonus',
                    '0.85 soit 15% de bonus',
                    '0.86 soit 14% de bonus',
                    '0.87 soit 13% de bonus',
                    '0.88 soit 12% de bonus',
                    '0.89 soit 11% de bonus',
                    '0.90 soit 10% de bonus',
                    '0.91 soit 9% de bonus',
                    '0.92 soit 8% de bonus',
                    '0.93 soit 7% de bonus',
                    '0.94 soit 6% de bonus',
                    '0.95 soit 5% de bonus',
                    '0.96 soit 4% de bonus',
                    '0.97 soit 3% de bonus',
                    '0.98 soit 2% de bonus',
                    '0.99 soit 1% de bonus',
                    '1.00 soit 0% de bonus',
                ],
                showRetourButton: false,
                CLIENT_CIVILITY,
                pdfWindow: null,
                numberOfDuplicates: 0,
                isOui: "Oui",
                isNon: "Non",
                isCheckingSubscription: false,
                payment_type: "year"
            }
        },
        computed: {
            getDownloadLinkConfirmationPdf() {
                if (this.guaranty.id)
                    return this.getApiAuthUrl('garantie/confirmation-pdf/' + this.guaranty.id);

                return '';
            },
            paymentTypePrice() {
                if (this.guaranty.price) {
                    let monthlyPrice = this.guaranty.payment_monthly_first || (this.guaranty.payment_monthly || (this.guaranty.price / 12));
                    let price = (this.payment_type === "month") ? +Number(monthlyPrice).toFixed(2) : +Number(this.guaranty.price).toFixed(2);
                    return `${price} €`;
                }
                return '';
            },
            monthlyPrice() {
                let monthlyPrice = this.guaranty.payment_monthly_first || (this.guaranty.payment_monthly || (this.guaranty.price / 12));
                return +Number(monthlyPrice).toFixed(2);
            },
            regularMonthlyPrice() {
                let monthlyPrice = this.guaranty.payment_monthly || (this.guaranty.price / 12);
                return +Number(monthlyPrice).toFixed(2);
            },
            calculatedYearPrice() {
                return +Number(this.guaranty.price).toFixed(2);
            },
            regularYearPrice() {
                if (this.guaranty.price_regular) {
                    return +Number(this.guaranty.price_regular).toFixed(2);
                }
                return +Number(this.guaranty.price).toFixed(2);
            },
            showGender() {
                return this.gender_list[this.guaranty.civility] ? this.gender_list[this.guaranty.civility] : '';
            },
            showFamilyStatus() {
                return this.family_status_list[this.guaranty.family] ? this.family_status_list[this.guaranty.family] : '';
            },
            showInsuranceAssistance() {
                return this.list_assistance_insurance[this.guaranty.assistance] ? this.list_assistance_insurance[this.guaranty.assistance] : '';
            },
            showPTC() {
                return this.list_ptc[this.guaranty.ptc] ? this.list_ptc[this.guaranty.ptc] : '';
            },
            showBonus() {
                return this.list_bonus_insurance[this.guaranty.bonus] ? this.list_bonus_insurance[this.guaranty.bonus] : '';
            },
            showProfession() {
                return this.professions_list[this.guaranty.profession] ? this.professions_list[this.guaranty.profession] : '';
            },
            // Details
            showGuaranty() {
                return this.guaranty_list[this.guaranty.garantie] ? this.guaranty_list[this.guaranty.garantie] : '';
            },
            showDuration() {
                if (this.guaranty && this.guaranty.details) {
                    return this.duration_list[this.guaranty.details.duration] ? this.duration_list[this.guaranty.details.duration] : '';
                }
            },
            getDownloadLink() {
                if (this.guaranty.id)
                    return this.getApiAuthUrl('insurances/generate-pdf/' + this.guaranty.id);

                return '';
            },
            getDownloadLinkCopyPdf() {
                if (this.guaranty.id)
                    return this.getApiAuthUrl('insurances/generate-front-details-pdf/' + this.guaranty.id);

                return '';
            },
            currentYear() {
                return this.moment(new Date()).format('Y');
            }
        },
        methods: {
            checkInsuranceSubscription(quote, getPdfMethod) {
                this.isCheckingSubscription = true;
            },
            parseCirculationDate(insurance) {
                let day = insurance.day_circulation,
                    month = insurance.month_circulation - 1,
                    year = insurance.year_circulation;

                (day && day.length < 2) ? day = '0' + day.toString() : '';
                (month && month.length < 2) ? month = '0' + month.toString() : '';

                if (!day || !month) {
                    return '';
                }

                let date = this.moment(new Date).date(day).month(month).year(year);
                return date.format('DD/MM/YYYY');
            },
            parseSaleDate(quoteDatails) {
                if (quoteDatails.sale_date) {
                    return this.moment(quoteDatails.sale_date).format('DD/MM/Y');
                }

                return '';
            },
            parseEffectiveDate(quoteDatails) {
                if (quoteDatails.effective_date) {
                    return this.moment(quoteDatails.effective_date).format('DD/MM/Y');
                }

                return '';
            },
            parseEffectiveDateEnd(quoteDatails) {
                if (quoteDatails.effective_date) {
                    return this.moment(quoteDatails.effective_date).add(12, 'month').subtract(1, 'days').format('DD/MM/Y');
                }

                return '';
            },
            parseEndDateOfYearPayment(quote) {
                if (quote.effective_date) {
                    let effectiveDateNextMonth = this.moment(quote.effective_date).add(1, 'M');
                    return effectiveDateNextMonth.endOf('month').format('DD/MM/Y');
                }

                return '';
            },
            showDateDeNaissance(insurance) {
                if (insurance.date_naissance) {
                    return this.moment(+insurance.date_naissance*1000).format('DD/MM/Y');
                }

                return '';
            },
            showDateDePermiss(insurance) {
                if (insurance.date_permis) {
                    return this.moment(+insurance.date_permis*1000).format('DD/MM/Y');
                }

                return '';
            },
            parseShippingDate(quoteDatails) {
                if (quoteDatails.shipping_date) {
                    return this.moment(quoteDatails.shipping_date).format('DD/MM/Y');
                }

                return '';
            },
            parseDeliveryDate(quoteDatails) {
                if (quoteDatails.delivery_date) {
                    return this.moment(quoteDatails.delivery_date).format('DD/MM/Y');
                }

                return '';
            },
            parseBirthDate(quoteDatails) {
                if (quoteDatails.client.birthday) {
                    let day = quoteDatails.client.datesParse.day_birth,
                        month = quoteDatails.client.datesParse.month_birth,
                        year = quoteDatails.client.datesParse.year_birth;
                    return this.moment(quoteDatails.client.birthday).format('DD/MM/Y');
                }

                return '';
            },
            getGuarantyInfo() {
                this.isBusy = true;
                let url = 'garantie/info-assurance/' + this.$route.params.id;
                this.apiGet(url).then(response => {
                    this.guaranty = response.data.insurance ? response.data.insurance : {};
                    // this.numberOfDuplicates = response.data.duplicates;
                    this.isBusy = false;
                }).catch(error => {
                    this.showErrorNotification(error);
                    this.$router.push('/');
                })
            },
            printInsurance() {
                window.print();
            },
            resendEmail() {
                this.isBusyResend = true;
                let url = 'garantie/resend-email/' + this.guaranty.id;

                this.apiPost(url, {}).then((response) => {
                    this.isBusyResend = false;
                    if (response.data.quote && response.data.status == 'success') {
                        this.showSuccessNotification(response.data.message, '');
                        this.$set(this.guaranty, 'was_sent', response.data.quote.was_sent);
                    }
                }).catch(error => {
                    this.isBusyResend = false;
                    this.showErrorNotification(error);
                })

            },
            getPDF() {
                // if (this.checkEffectiveDate(this.guaranty)) {
                    this.refreshTokenForce().then((response) => {
                        if (this.getDownloadLink) {
                            let pdfWindow = window.open(this.getDownloadLink);
                            if (pdfWindow) this.pdfWindow = pdfWindow;
                        } else {
                            this.showWarningNotification('Quote Not Found');
                        }
                    }).catch(error => {
                        this.showErrorNotification(error);
                    });
                // } else {
                //     this.showWarningNotification('La garantie ne peut-être souscrite à une date antérieur. <br> Veuillez modifier la date de prise d\'effet de la garantie.');
                // }
            },
            getConfirmationPDF() {
                this.refreshTokenForce().then((response) => {
                    if (this.getDownloadLinkConfirmationPdf) {
                        window.location = this.getDownloadLinkConfirmationPdf;
                    } else {
                        this.showWarningNotification('Quote Not Found');
                    }
                }).catch(error => {
                    console.log(error)
                    this.showErrorNotification(error);
                });
            },
            getFrontPdf() {
                this.refreshTokenForce().then((response) => {
                    if (this.getDownloadLinkCopyPdf) {
                        window.open(this.getDownloadLinkCopyPdf);
                    } else {
                        this.showWarningNotification('Quote Not Found');
                    }
                }).catch(error => {
                    this.showErrorNotification(error);
                });
            },
            isNewCar (quoteDatails) {
              if (quoteDatails.is_new === this.isOui) {
                return this.isOui;
              }
              return this.isNon;
            },
            getKmReal (quoteDatails) {
              if (quoteDatails.km_real !== null) {
                return `${quoteDatails.km_real} km`;
              }
              return quoteDatails.km_real || '';
            },
            getKmLimit (quoteDatails) {
                if (quoteDatails.km_day !== null) {
                  return `${quoteDatails.km_day} km`;
                }
                return quoteDatails.km_day || '';
              },
            showAssistanceMode (quoteDetails) {
              if (typeof quoteDetails !== 'undefined') {
                return (+quoteDetails.assistance === 1) ? this.isNon : this.isOui;
              }
              return this.isNon;
            },
            showAssistancePrice (quote) {
              if (typeof quote['assistance_price'] !== 'undefined') {
                return `${this.formatFloatNumberWithComma(`${quote['assistance_price']}`)} TTC (Taxe d’Assurance. 18%)`;
              }
            },
            getPrice(quote) {
              if (typeof quote['price'] !== 'undefined') {
                return quote.price ? this.roundEURWithoutSymbol(quote.price).replace('.', ',') + ' €' : 'Veuillez contacter le siège pour demander une dérogation.';
              }
            },
            getRegularPrice(quote) {
              if (typeof quote['price_regular'] !== 'undefined') {
                return quote.price_regular ? this.roundEURWithoutSymbol(quote.price_regular).replace('.', ',') + ' €' : 'Veuillez contacter le siège pour demander une dérogation.';
              }
              return this.getPrice(quote);
            },
            isNewCampingCar(quoteDetails) {
              if (typeof quoteDetails !== 'undefined') {
                return (quoteDetails.is_new === this.isOui);
              }
              return false;
            },
            isPackAssistance(quoteDetails) {
              if (typeof quoteDetails !== 'undefined') {
                return +quoteDetails.assistance === 0;
              }
              return false;
            }
        },
        mounted() {
            document.body.classList.add('print-copy-insurance');
            this.getGuarantyInfo();
            this.$eventBus.$emit('sidebar-set-active-tab', 'Assurance Tous Risques');

            if (this.$store.state.backToDevisListActive) {
                this.showRetourButton = true;
                this.$store.dispatch('backToDevisDisable');
            }
        },
        beforeDestroy() {
            document.body.classList.remove('print-copy-insurance');
            this.$eventBus.$emit('sidebar-set-active-tab', '');
        },
        watch: {
            pdfWindow: function () {
                this.$router.push(`/clients`);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/DealerInsuranceCampingCar/DevisEnLigneAssuranceView.vue